export default __webpack_public_path__ + "static/media/userperfil.2fda6558.png";